<template>
    <v-select
        v-model="value"
        :dense="dense"
        :disabled="disabled"
        :rules="rules"
        :items="items"
        item-text="nombre"
        item-value="id"
        label="Desarmadero"
        @change="change"
        @focus="focus"
        :menu-props="{ auto: true, botton: true, offsetY: true }"
    >
        >
    </v-select>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'selectDesarmadero',
    props: ['value', 'texto', 'clienteId', 'disabled', 'rules', 'dense'],
    data: function() {
        return {
            pvalue: 0,
            ptexto: ''
        };
    },
    watch: {
        clienteId(newval) {
            if (newval != null) this.getxcliente(newval);
        }
    },
    computed: {
        ...mapState('desarmadero', ['items'])
    },
    methods: {
        ...mapActions('desarmadero', ['getxcliente']),
        change(id) {
            this.$emit('input', id);
            var r = this.items.find(function(item) {
                if (item.id === id) {
                    return item.nombre;
                }
            });
            this.$emit('texto', r.nombre);
            this.$emit('change', r);
        },
        focus(id) {
            this.pvalue = this.value;
            this.ptexto = this.texto;
        }
    },
    mounted() {
        if (this.clienteId != null) this.getxcliente(this.clienteId);
    }
};
</script>
